import get from 'lodash/get';
import PropTypes from 'prop-types';

const useLastAccessedUnit = (props) => {
  const { visitedUnits, subjectId, initId, unit } = props;

  return (
    get(visitedUnits, [`${subjectId}-${initId}`, 'unitNumber'], unit) || '1'
  );
};

useLastAccessedUnit.propTypes = {
  visitedUnits: PropTypes.object.isRequired,
  subjectId: PropTypes.string.isRequired,
  initId: PropTypes.string.isRequired,
};

export default useLastAccessedUnit;
